/* ──────────────────────────────
   store/badge/action.js
   ────────────────────────────── */
   import axios                from "axios";
   import { Toast }            from "../../util/Toast";
   import {
     GET_BADGES,
     ADD_BADGE,
     UPDATE_BADGE,
     DELETE_BADGE,
   } from "./types";
   
   /* ─────────────────────────────────────────────────────────────
      1. GET  — simple list (no paging query-params)
      ─────────────────────────────────────────────────────────── */
   export const getBadges = () => async (dispatch) => {
     try {
       /*  apiInstanceFetch was giving trouble; axios always returns
           { data: … } so we keep it simple and consistent here.        */
       const { data } = await axios.get("badge/badges");
   
       if (data.status) {
         dispatch({
           type   : GET_BADGES,
           payload: {
             badges: data.badges,
             total : data.badges.length,
           },
         });
       } else {
         Toast("error", data.message || "Failed to fetch badges");
       }
     } catch (err) {
       Toast("error", err.message);
     }
   };
   
   /* ─────────────────────────────────────────────────────────────
      2. POST — create
      ─────────────────────────────────────────────────────────── */
   export const createBadge = (formData) => (dispatch) => {
     axios
       .post("badge/badges", formData)
       .then((res) => {
         if (res.data.status) {
           dispatch({ type: ADD_BADGE, payload: res.data.badge });
           Toast("success", "Badge created!");
         } else {
           Toast("error", res.data.message);
         }
       })
       .catch((err) => Toast("error", err.message));
   };
   
   /* ─────────────────────────────────────────────────────────────
      3. PATCH — update
      ─────────────────────────────────────────────────────────── */
   export const updateBadge = (badgeId, formData) => (dispatch) => {
     axios
       .patch(`badge/badges/${badgeId}`, formData)
       .then((res) => {
         if (res.data.status) {
           dispatch({ type: UPDATE_BADGE, payload: res.data.badge });
           Toast("success", "Badge updated!");
         } else {
           Toast("error", res.data.message);
         }
       })
       .catch((err) => Toast("error", err.message));
   };
   
   /* ─────────────────────────────────────────────────────────────
      4. DELETE — remove
      ─────────────────────────────────────────────────────────── */
   export const deleteBadge = (badgeId) => (dispatch) => {
     axios
       .delete(`badge/badges/${badgeId}`)
       .then((res) => {
         if (res.data.status) {
           dispatch({ type: DELETE_BADGE, payload: badgeId });
           Toast("success", "Badge deleted!");
         } else {
           Toast("error", res.data.message);
         }
       })
       .catch((err) => Toast("error", err.message));
   };
   